import { fromJstInput, toJstInput } from './time';

const ERR = 'subscription.admin.campaigns.error';
const ALL_FIELDS = ['name', 'features', 'scope', 'startsAt', 'endsAt'];

export const INITIAL_FORM = {
  name: '',
  features: [],
  allTeams: false,
  teams: [],
  startsAt: '',
  endsAt: ''
};

export const campaignToForm = (c) => ({
  name: c.name,
  features: c.features,
  allTeams: !!c.scope?.all,
  teams: c.scope?.teamIds ?? [],
  startsAt: toJstInput(c.startsAt),
  endsAt: toJstInput(c.endsAt)
});

export const buildCampaignPayload = (form) => ({
  name: form.name.trim(),
  features: form.features,
  scope: { all: form.allTeams, teamIds: form.allTeams ? [] : form.teams.map((t) => t._id) },
  startsAt: fromJstInput(form.startsAt),
  endsAt: fromJstInput(form.endsAt)
});

export function validateCampaignForm(form) {
  const errors = {};
  const startsAt = fromJstInput(form.startsAt);
  const endsAt = fromJstInput(form.endsAt);
  if (!form.name.trim()) errors.name = `${ERR}.nameRequired`;
  if (form.features.length === 0) errors.features = `${ERR}.featuresRequired`;
  if (!form.allTeams && form.teams.length === 0) errors.teams = `${ERR}.teamsRequired`;
  if (!startsAt) errors.startsAt = `${ERR}.startRequired`;
  if (!endsAt) errors.endsAt = `${ERR}.endRequired`;
  else if (startsAt && new Date(endsAt) <= new Date(startsAt)) errors.endsAt = `${ERR}.endAfterStart`;
  return errors;
}

export function editableFields(status) {
  if (status === 'scheduled') return ALL_FIELDS;
  return status === 'active' ? ['name', 'endsAt'] : [];
}

export function pickEditable(payload, status) {
  const allowed = editableFields(status);
  return Object.fromEntries(Object.entries(payload).filter(([key]) => allowed.includes(key)));
}

export const toggleFeature = (features, key) =>
  features.includes(key) ? features.filter((f) => f !== key) : [...features, key];
